import { isNil } from 'lodash-es';
import { atom, useAtomValue } from 'jotai';
import fetchFlag, { FlagKey } from 'services/api/flagr';
import { orgState } from './useOrg';
import { atomFamily, loadable } from 'jotai/utils';
import { Response as FlagrResponse } from 'services/api/flagr';

const orgIdState = atom((get) => get(orgState)?.orgId);

export const flagrState = atomFamily((flagKey: FlagKey) =>
  atom(async (get) => {
    const orgId = get(orgIdState);
    if (!isNil(orgId)) {
      const flag = await fetchFlag(flagKey, { orgId } as any);
      return flag;
    }
    return undefined;
  }),
);

export const useFlagrChannelModulesValue = () => {
  const value = useAtomValue(loadable(flagrState(FlagKey.ChannelModules)));
  return value.state === 'hasData'
    ? (value.data as FlagrResponse[FlagKey.ChannelModules])
    : undefined;
};

export const useFlagrZhixiaModulesValue = () => {
  const value = useFlagrChannelModulesValue();
  return value?.zhixia;
};

export const useFlagrWelfareCenterValue = () => {
  const value = useAtomValue(loadable(flagrState(FlagKey.WelfareCenter)));
  return value.state === 'hasData'
    ? (value.data as FlagrResponse[FlagKey.WelfareCenter])
    : undefined;
};

export const useFlagrDashboardRankValue = () => {
  const value = useAtomValue(loadable(flagrState(FlagKey.DashboardRankEnable)));
  return value.state === 'hasData'
    ? (value.data as FlagrResponse[FlagKey.DashboardRankEnable])
    : undefined;
};

export const usePaySupportFlagrValue = () => {
  const value = useAtomValue(loadable(flagrState(FlagKey.PaySupport)));
  return (value.state === 'hasData' ? value.data : {}) as FlagrResponse[FlagKey.PaySupport];
};
